// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { CustomPageListView } from "../schema";

export function serialize_CustomPageListView_internal(value: CustomPageListView): unknown {
  return ((value: { corporateId: number; coverUri: string; customPageId: bigint; description: string | null; title: string }): unknown => {
    return {
      corporateId: ((value: number): unknown => {
        return value;
      })(value["corporateId"]),
      coverUri: ((value: string): unknown => {
        return value;
      })(value["coverUri"]),
      customPageId: ((value: bigint): unknown => {
        return value;
      })(value["customPageId"]),
      description: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["description"]),
      title: ((value: string): unknown => {
        return value;
      })(value["title"]),
    };
  })(value);
}
export function serialize_CustomPageListView(obj: CustomPageListView): string {
  return renderJsonWithNumbersAsBigint(serialize_CustomPageListView_internal(obj));
}
export function deserialize_CustomPageListView_internal(value: unknown): ParserResult<CustomPageListView> {
  return ((
    value: unknown,
  ): ParserResult<{
    corporateId: number;
    coverUri: string;
    customPageId: bigint;
    description: string | null;
    title: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/CustomPageListView]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/CustomPageListView]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "corporateId")) {
      return { success: false, reason: `[#/components/schemas/CustomPageListView/corporateId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'corporateId'.` };
    }
    const parsed_corporateId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/CustomPageListView/corporateId]: '${value}' expected to be of type number.` };
      })(value["corporateId"]);
    })();
    if (!parsed_corporateId.success) {
      return { success: false, reason: parsed_corporateId.reason };
    }
    if (!hasProp(value, "coverUri")) {
      return { success: false, reason: `[#/components/schemas/CustomPageListView/coverUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverUri'.` };
    }
    const parsed_coverUri = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/CustomPageListView/coverUri]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["coverUri"]);
    })();
    if (!parsed_coverUri.success) {
      return { success: false, reason: parsed_coverUri.reason };
    }
    if (!hasProp(value, "customPageId")) {
      return { success: false, reason: `[#/components/schemas/CustomPageListView/customPageId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customPageId'.` };
    }
    const parsed_customPageId = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/CustomPageListView/customPageId]: '${value}' expected to be of type bigint or number.` };
      })(value["customPageId"]);
    })();
    if (!parsed_customPageId.success) {
      return { success: false, reason: parsed_customPageId.reason };
    }
    if (!hasProp(value, "description")) {
      return { success: false, reason: `[#/components/schemas/CustomPageListView/description]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'description'.` };
    }
    const parsed_description = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/CustomPageListView/description]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["description"]);
    })();
    if (!parsed_description.success) {
      return { success: false, reason: parsed_description.reason };
    }
    if (!hasProp(value, "title")) {
      return { success: false, reason: `[#/components/schemas/CustomPageListView/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
    }
    const parsed_title = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/CustomPageListView/title]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["title"]);
    })();
    if (!parsed_title.success) {
      return { success: false, reason: parsed_title.reason };
    }
    return { success: true, value: { corporateId: parsed_corporateId.value, coverUri: parsed_coverUri.value, customPageId: parsed_customPageId.value, description: parsed_description.value, title: parsed_title.value } };
  })(value);
}
export function deserialize_CustomPageListView(str: string): ParserResult<CustomPageListView> {
  return deserialize_CustomPageListView_internal(parseJsonWithNumbersAsBigint(str));
}
